import { render, staticRenderFns } from "./VisualizarTerritorioParaguai.vue?vue&type=template&id=bd278280&lang=pug"
import script from "./VisualizarTerritorioParaguai.vue?vue&type=script&lang=js"
export * from "./VisualizarTerritorioParaguai.vue?vue&type=script&lang=js"
import style0 from "./VisualizarTerritorioParaguai.vue?vue&type=style&index=0&id=bd278280&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports